interface Props {
    pageName: string
}

export const PageTitle = ({pageName} : Props) => {
    return (
        <div className="h-24 w-full flex items-center">
            <div className="pages-title-t">{pageName}</div>
        </div>
    )
}